import { render } from "./Phone.vue?vue&type=template&id=98238530&scoped=true&lang=pug"
import script from "./Phone.vue?vue&type=script&setup=true&lang=js"
export * from "./Phone.vue?vue&type=script&setup=true&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=98238530&lang=stylus&scoped=true"

import exportComponent from "/Users/lizhi/Documents/youdao/panda-course-claim/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98238530"]])

export default __exports__